import { render, staticRenderFns } from "./Regjoin.vue?vue&type=template&id=11251458&scoped=true"
import script from "./Regjoin.vue?vue&type=script&lang=js"
export * from "./Regjoin.vue?vue&type=script&lang=js"
import style0 from "./Regjoin.vue?vue&type=style&index=0&id=11251458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11251458",
  null
  
)

export default component.exports